import { Component, input, output } from '@angular/core';
import { MatPrefix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { BackButtonDirective } from '@core';

@Component({
  imports: [MatIcon, BackButtonDirective, MatPrefix, RouterLink],
  selector: 'avs-mobile-nested-page-header',
  templateUrl: './nested-page-header.component.html',
})
export class NestedPageHeaderComponent {
  titleName = input();
  title = input.required();
  backHomeLink = input(false);
  simpleBackLink = input(false);
  directLink = input<string | null>(null);
  callbackButton = input(false);
  buttonCallback = output();
}
